import { useHistory } from 'react-router-dom'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'
import { Security } from '@okta/okta-react'
import { getAuthProviderConfigFromEnv } from '../../Utilities/utilities'

const OktaAuthProvider: React.FC = ({ children }) => {
  const config = getAuthProviderConfigFromEnv()
  const oktaAuth = new OktaAuth(config.oidc)
  const history = useHistory()

  const restoreOriginalUri = async (
    _oktaAuth: OktaAuth,
    originalUri: string
  ) => {
    const basepath = history.createHref({})
    const originalUriWithoutBasepath = originalUri?.replace(basepath, '/')
    history.replace(
      toRelativeUrl(originalUriWithoutBasepath, window.location.origin)
    )
  }

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  )
}

export default OktaAuthProvider
